import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../../components/modal/modal.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ProfileService } from '../../services/profile.service';
import { ToastService } from '../../components/toast/toast.service';

@Component({
  selector: 'lowy-change-password',
  template: `
  <lowy-modal #modal>
    <div class="form">
      <div class="headline">Change Password</div>
      <div class="subheading">It’s a good idea to use a strong password that you’re not using elsewhere.</div>
      <div class="seperator"></div>
      <form [formGroup]="changePasswordForm" (ngSubmit)="save()">
        <mat-form-field>
          <input matInput placeholder="Current password" formControlName="currentPassword" type="password">
        </mat-form-field>
        <span class="input-error-message" *ngIf="errorMessage">{{errorMessage}}</span>
        <mat-form-field>
          <input matInput placeholder="New password" formControlName="newPassword" type="password" (blur)="validatePasswordMatch()">
        </mat-form-field>
        <span class="input-error-message" *ngIf="newPasswordMismatch && newPassword.dirty && confirmNewPassword.dirty">
          Passwords must match</span>
        <span class="input-error-message" *ngIf="newPassword.invalid && newPassword.dirty">
          Password must use at least 8 characters, include both an uppercase letter and a number</span>
        <span class="input-sub-heading" *ngIf="(newPassword.valid || newPassword.pristine)">
          Use at least 8 characters, include both an uppercase letter and a number</span>
        <mat-form-field>
          <input matInput placeholder="Confirm new password" formControlName="confirmNewPassword"
          type="password" (blur)="validatePasswordMatch()">
        </mat-form-field>
      </form>
      <div class="seperator"></div>
      <div class="button-row">
        <span (click)="cancel()">cancel</span>
        <span [ngClass]="{disabled: !changePasswordForm.valid && !newPasswordMismatch}" (click)="save()">save</span>
      </div>
    </div>
  </lowy-modal>
  `,
  providers: [ ProfileService ]
})
export class ChangePasswordComponent {
  changePasswordForm: FormGroup;
  newPasswordMismatch: boolean;
  errorMessage: string;

  @ViewChild('modal') modal: ModalComponent;

  constructor(private formBuilder: FormBuilder, private profileService: ProfileService, private toastService: ToastService) {
    this.buildForm();
  }

  public open() {
    this.modal.open();
  }

  async buildForm() {
    this.changePasswordForm = this.formBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.compose([Validators.required, Validators.pattern(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z].{8,}/)])],
      confirmNewPassword: ['', Validators.required]
    });
  }

  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }
  get confirmNewPassword() {
    return this.changePasswordForm.get('confirmNewPassword');
  }

  async save() {
    this.errorMessage = null;

    try {
      await this.profileService.checkPassword(this.changePasswordForm.value.currentPassword);
    }
    catch (err) {
      this.errorMessage = err.message;
      return;
    }

    try {
      await this.profileService.updatePassword(this.changePasswordForm.value.newPassword);
      this.changePasswordForm.reset();
      this.modal.close();
      this.toastService.throwToast('Password change successful');
    }
    catch (err) {
      this.changePasswordForm.reset();
      this.modal.close();
      this.toastService.throwToast('Error updating password: ' + err);
    }
  }

  validatePasswordMatch() {
    if (this.changePasswordForm.get('newPassword').dirty && this.changePasswordForm.get('confirmNewPassword').dirty) {
      if (this.changePasswordForm.value.newPassword !== this.changePasswordForm.value.confirmNewPassword) {
        this.newPasswordMismatch = true;
        return;
      }
    }

    this.newPasswordMismatch = false;
  }

  cancel() {
    this.changePasswordForm.reset();
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/header/change-password-modal.component.ts